import { z } from "zod";
import { memberIdSchema, tenantIdSchema } from "./ids.js";
import { visibilityClassSchema } from "./vocabulary.js";
export const dateTimeSchema = z.string().datetime({ offset: true });
export const sha256Schema = z
    .string()
    .regex(/^[a-f0-9]{64}$/)
    .transform((value) => value);
export const nonEmptyStringSchema = z.string().trim().min(1).max(4096);
export const nullableNonEmptyStringSchema = nonEmptyStringSchema.nullable();
export const tenantOwnedShape = {
    tenantId: tenantIdSchema,
};
export const visibilityShape = {
    visibility: visibilityClassSchema,
    ownerMemberId: memberIdSchema.nullable(),
};
export function enforceVisibilityInvariant(value, context) {
    if (value.visibility === "owner_private" && value.ownerMemberId === null) {
        context.addIssue({
            code: "custom",
            path: ["ownerMemberId"],
            message: "owner_private records require ownerMemberId.",
        });
    }
}
export function enforceSameTenant(tenantId, references, context) {
    for (const reference of references) {
        if (reference.tenantId !== tenantId) {
            context.addIssue({
                code: "custom",
                path: [...reference.path],
                message: "Cross-tenant references are forbidden.",
            });
        }
    }
}
/**
 * Mirror of the `valid_to is null or valid_from is null or valid_to >=
 * valid_from` check that `app_private.claims` and `app_private.resolved_facts`
 * both carry.
 *
 * Without a domain-side twin the only thing that ever states this invariant is
 * the database, and a producer that breaks it learns so as an anonymous 23514
 * at insert time — after the surrounding transaction has already built the
 * document's whole row set, so every claim of that document is rolled back and
 * the job burns its full retry budget on an outcome that can never change.
 * Refusing the record where it is constructed names the offending field instead.
 */
export function enforceTemporalBounds(value, context) {
    if (value.validFrom === null || value.validTo === null)
        return;
    if (Date.parse(value.validTo) >= Date.parse(value.validFrom))
        return;
    context.addIssue({
        code: "custom",
        path: ["validTo"],
        message: "validTo must not precede validFrom.",
    });
}
export const jsonScalarSchema = z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
]);
//# sourceMappingURL=common.js.map